import { LookupModel } from '../../../../api/models';

export const LANGUAGE_CODES_DEEPGRAM: LookupModel[] = [
  { text: 'Automatic Language Detection', id: 'auto' },
  { text: 'Multilingual (Spanish + English)', id: 'multi' },
  { text: 'Bulgarian', id: 'bg' },
  { text: 'Catalan', id: 'ca' },
  { text: 'Chinese (Mandarin, Simplified)', id: 'zh-CN' },
  { text: 'Chinese (Mandarin, Traditional)', id: 'zh-TW' },
  { text: 'Chinese (Cantonese, Traditional)', id: 'zh-HK' },
  { text: 'Czech', id: 'cs' },
  { text: 'Danish', id: 'da' },
  { text: 'Dutch', id: 'nl' },
  { text: 'English', id: 'en' },
  { text: 'English (US)', id: 'en-US' },
  { text: 'English (Australia)', id: 'en-AU' },
  { text: 'English (Britain)', id: 'en-GB' },
  { text: 'English (New Zealand)', id: 'en-NZ' },
  { text: 'English (India)', id: 'en-IN' },
  { text: 'Estonian', id: 'et' },
  { text: 'Finnish', id: 'fi' },
  { text: 'Flemish', id: 'nl-BE' },
  { text: 'French', id: 'fr' },
  { text: 'French (Canada)', id: 'fr-CA' },
  { text: 'German', id: 'de' },
  { text: 'German (Switzerland)', id: 'de-CH' },
  { text: 'Greek', id: 'el' },
  { text: 'Hindi', id: 'hi' },
  { text: 'Hungarian', id: 'hu' },
  { text: 'Indonesian', id: 'id' },
  { text: 'Italian', id: 'it' },
  { text: 'Japanese', id: 'ja' },
  { text: 'Korean (South Korea)', id: 'ko-KR' },
  { text: 'Latvian', id: 'lv' },
  { text: 'Lithuanian', id: 'lt' },
  { text: 'Malay', id: 'ms' },
  { text: 'Norwegian', id: 'no' },
  { text: 'Polish', id: 'pl' },
  { text: 'Portuguese (Brazil)', id: 'pt-BR' },
  { text: 'Portuguese (Portugal)', id: 'pt-PT' },
  { text: 'Romanian', id: 'ro' },
  { text: 'Russian', id: 'ru' },
  { text: 'Slovak', id: 'sk' },
  { text: 'Spanish', id: 'es' },
  { text: 'Spanish (Latin America)', id: 'es-419' },
  { text: 'Swedish', id: 'sv-SE' },
  { text: 'Thai', id: 'th-TH' },
  { text: 'Turkish', id: 'tr' },
  { text: 'Ukrainian', id: 'uk' },
  { text: 'Vietnamese', id: 'vi' },
];
